export interface ControlCatalogItem {
  id: string;
  name: string;
  description: string;
}

// Control Catalog v1 (VE-Cxx)
// Kept small and human-auditable. Framework mappings (e.g. NIS2) are optional outputs.
export const CONTROL_CATALOG_V1: ControlCatalogItem[] = [
  {
    id: "VE-C01",
    name: "Asset inventory per site",
    description: "Enumerate devices per site with time-bounded exports."
  },
  {
    id: "VE-C02",
    name: "Identity RBAC and least privilege",
    description: "Define roles and record access-relevant events."
  },
  {
    id: "VE-C03",
    name: "Privileged change accountability",
    description: "Record admin and configuration actions in an append-only audit trail."
  },
  {
    id: "VE-C04",
    name: "Time synchronization",
    description: "Ensure events and exports are attributable across sites."
  },
  {
    id: "VE-C05",
    name: "Telemetry integrity and lineage",
    description: "Attach lineage fields and produce reproducible hashes."
  },
  {
    id: "VE-C06",
    name: "Immutable audit logging",
    description: "Maintain tamper-evident logs for key actions."
  },
  {
    id: "VE-C07",
    name: "Monitoring coverage",
    description: "Provide fleet health summaries and per-site status."
  },
  {
    id: "VE-C08",
    name: "Alert handling and acknowledgements",
    description: "Track alerts and acknowledgements with accountability."
  },
  {
    id: "VE-C09",
    name: "Patch cadence evidence (where in scope)",
    description: "Collect patch-related signals without PII."
  },
  {
    id: "VE-C10",
    name: "Continuity offline buffering",
    description: "Buffer evidence during outages at the edge."
  },
  {
    id: "VE-C11",
    name: "Continuity lossless backfill",
    description: "Reconcile buffered evidence after reconnect with no gaps."
  },
  {
    id: "VE-C12",
    name: "Evidence pack generation",
    description: "Generate time-scoped, auditor-friendly evidence packs."
  },
  {
    id: "VE-C13",
    name: "Control-to-evidence mapping",
    description: "Index which artifacts support which controls."
  },
  {
    id: "VE-C14",
    name: "EU-only hosting and zero-PII telemetry",
    description: "Constrain processing to EU and avoid PII collection."
  },
  {
    id: "VE-C15",
    name: "Supply chain SBOM and attestation",
    description: "Provide SBOM and provenance evidence where available."
  }
];
